import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LeaderboardComponent } from './pages/leaderboard/leaderboard.component';
import { ContactComponent } from './pages/contact/contact.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CariqCloudComponent } from './pages/products/cariq-cloud/cariq-cloud.component';
import { CariqInsuranceCloudComponent } from './pages/products/cariq-insurance-cloud/cariq-insurance-cloud.component';
import { CariqTlsCloudComponent } from './pages/products/cariq-tls-cloud/cariq-tls-cloud.component';
import { CariqScoreComponent } from './pages/products/cariq-score/cariq-score.component';
import { CariqApplicationsComponent } from './pages/products/cariq-applications/cariq-applications.component';
import { AutomotiveSolutionComponent } from './pages/solutions/automotive-solution/automotive-solution.component';
import { TlsSolutionComponent } from './pages/solutions/tls-solution/tls-solution.component';
import { VarrocConnectHardwareComponent } from './pages/products/varroc-connect-hardware/varroc-connect-hardware.component';
import { BfsiComponent } from './pages/solutions/bfsi/bfsi.component';
import { VehicleUsersComponent } from './pages/solutions/vehicle-users/vehicle-users.component';
import { AboutUsComponent } from './pages/policy-pages/about-us/about-us.component';
import { PrivacyPolicyComponent } from './pages/policy-pages/privacy-policy/privacy-policy.component';
import { RefundAndReturnComponent } from './pages/policy-pages/refund-and-return/refund-and-return.component';
import { CancellationPolicyComponent } from './pages/policy-pages/cancellation-policy/cancellation-policy.component';
import { TermsAndConditionsComponent } from './pages/policy-pages/terms-and-conditions/terms-and-conditions.component';
import { BusinessLocationComponent } from './pages/business-location/business-location.component';
import { CyberSecurityComponent } from './pages/policy-pages/cyber-security/cyber-security.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { BasicLayoutComponent } from './layout/basic-layout/basic-layout.component';
import { EulaWebviewComponent } from './shared/eula-webview/eula-webview.component';
import { PrivacyPolicyWebviewComponent } from './shared/privacy-policy-webview/privacy-policy-webview.component';
import { IlassistPrivacyPolicyComponent } from './pages/ilassist-privacy-policy/ilassist-privacy-policy.component';
// New pages
import { PlatformComponent } from './pages/platform/platform.component';
import { ForBusinessComponent } from './pages/solutions/for-business/for-business.component';
import { ForConsumersComponent } from './pages/solutions/for-consumers/for-consumers.component';
import { HardwarePageComponent } from './pages/products/hardware-page/hardware-page.component';
import { ConnectIQComponent } from './pages/products/connectiq/connectiq.component';
import { UnitedSDKComponent } from './pages/products/unitedsdk/unitedsdk.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { MediaComponent } from './pages/media/media.component';
// ConnectIQ sub-pages
import { BabelfishComponent } from './pages/products/connectiq/babelfish/babelfish.component';
import { W4IQComponent } from './pages/products/connectiq/w4iq/w4iq.component';
import { VCScoreComponent } from './pages/products/connectiq/vc-score/vc-score.component';
import { MilesComponent } from './pages/products/connectiq/miles/miles.component';
import { VStoreComponent } from './pages/products/connectiq/vstore/vstore.component';
import { CAPComponent } from './pages/products/connectiq/cap/cap.component';
// ConnectIQ new microsites
import { OasisComponent } from './pages/products/connectiq/oasis/oasis.component';
import { IIOTComponent } from './pages/products/connectiq/iiot/iiot.component';
import { VehicleAppStoreComponent } from './pages/products/connectiq/vehicle-app-store/vehicle-app-store.component';
import { CertificateManagementSystemComponent } from './pages/products/connectiq/certificate-management-system/certificate-management-system.component';
import { ContextBasedMessagingComponent } from './pages/products/connectiq/context-based-messaging/context-based-messaging.component';
// Solutions For Business sub-pages
import { AutomotiveOEMComponent } from './pages/solutions/for-business/automotive-oem/automotive-oem.component';
import { FleetLogisticsComponent } from './pages/solutions/for-business/fleet-logistics/fleet-logistics.component';
import { InsuranceBFSIComponent } from './pages/solutions/for-business/insurance/insurance.component';
import { EnterpriseComponent } from './pages/solutions/for-business/enterprise/enterprise.component';
// Solutions For Consumers sub-pages
import { ConnectedCarComponent } from './pages/solutions/for-consumers/connected-car/connected-car.component';
import { SafetyAlertsComponent } from './pages/solutions/for-consumers/safety-alerts/safety-alerts.component';
import { ConsumerRewardsComponent } from './pages/solutions/for-consumers/rewards/rewards.component';
import { DeviceStoreComponent } from './pages/solutions/for-consumers/device-store/device-store.component';
// Unified SDK sub-pages
import { MobileSDKComponent } from './pages/products/unitedsdk/mobile-sdk/mobile-sdk.component';
import { WebSDKComponent } from './pages/products/unitedsdk/web-sdk/web-sdk.component';
import { IoTSDKComponent } from './pages/products/unitedsdk/iot-sdk/iot-sdk.component';
// Hardware sub-pages
import { OBDDongleComponent } from './pages/products/hardware-page/obd-dongle/obd-dongle.component';
import { TCUComponent } from './pages/products/hardware-page/tcu/tcu.component';
import { DashCamComponent } from './pages/products/hardware-page/dashcam/dashcam.component';
import { DigitalClusterComponent } from './pages/products/hardware-page/digital-cluster/digital-cluster.component';
import { SolutionsLandingComponent } from './pages/solutions/solutions-landing/solutions-landing.component';
import { ProductsLandingComponent } from './pages/products/products-landing/products-landing.component';
// Admin - Greetings
import { GreetingsDashboardComponent } from './pages/admin/greetings/greetings-dashboard.component';
import { DashcamInstallationVideo } from './shared/dashcam-installation-video/dashcam-installation-video.component';
import { CamzoComingSoonComponent } from './shared/camzo-coming-soon.component';

const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    children: [
      { path: "", component: DashboardComponent },
      { path: "leadership", component: LeaderboardComponent },
      { path: "html-sitemap.html", redirectTo: "/assets/html-sitemap.html", pathMatch: "full" },
      // Legacy product routes (kept for backward compatibility)
      // { path: "products/automotive-cloud", component: CariqCloudComponent },
      // { path: "Varroc-Connect-Insurance-Cloud", component: CariqInsuranceCloudComponent },
      // { path: "Varroc-Connect-TLS-Cloud", component: CariqTlsCloudComponent },
      // { path: "products/automotive-score", component: CariqScoreComponent },
      // { path: "products/automotive-applications", component: CariqApplicationsComponent },
      // { path: "products/automotive-hardware", component: VarrocConnectHardwareComponent },
      // New product routes
      { path: "products", component: ProductsLandingComponent },
      { path: "products/hardware", component: HardwarePageComponent },
      { path: "products/connectiq", component: ConnectIQComponent },
      { path: "products/connectiq/babelfish", component: BabelfishComponent },
      { path: "products/connectiq/w4iq", component: W4IQComponent },
      { path: "products/connectiq/vc-score", component: VCScoreComponent },
      { path: "products/connectiq/miles", component: MilesComponent },
      { path: "products/connectiq/vstore", component: VStoreComponent },
      { path: "products/connectiq/cap", component: CAPComponent },
      // ConnectIQ new microsites
      { path: "products/connectiq/oasis", component: OasisComponent },
      { path: "products/connectiq/iiot", component: IIOTComponent },
      { path: "products/connectiq/vehicle-app-store", component: VehicleAppStoreComponent },
      { path: "products/connectiq/secureiq", component: CertificateManagementSystemComponent },
      { path: "products/connectiq/iq360", component: ContextBasedMessagingComponent },
      { path: "products/connectiq/context-based-messaging", redirectTo: "products/connectiq/iq360" },
      { path: "products/unifiedsdk", component: UnitedSDKComponent },
      // Unified SDK sub-pages
      // { path: "products/unifiedsdk/mobile", component: MobileSDKComponent },
      // { path: "products/unifiedsdk/web", component: WebSDKComponent },
      // { path: "products/unifiedsdk/iot", component: IoTSDKComponent },
      // Hardware sub-pages
      { path: "products/hardware/obd", component: OBDDongleComponent },
      { path: "products/hardware/tcu", component: TCUComponent },
      { path: "products/hardware/dashcam", component: DashCamComponent },
      { path: "products/hardware/cluster", component: DigitalClusterComponent },
      // Platform
      { path: "platform", component: PlatformComponent },
      // Resources
      { path: "resources", component: ResourcesComponent },
      { path: "media", component: MediaComponent, data: { title: 'Media Gallery' } },
      // Blog
      { path: "blog", loadChildren: () => import('./pages/blog/blog.module').then(m => m.BlogModule) },
      // Solutions
      // { path: "solutions/automotive-smart-solutions", component: AutomotiveSolutionComponent },
      // { path: "solutions/automotive-tls-solutions", component: TlsSolutionComponent },
      // { path: "solutions/automotive-banking-finance-insurance-services", component: BfsiComponent },
      // { path: "solutions/automotive-vehicle-users-b2c-solutions", component: VehicleUsersComponent },
      { path: "solutions", component: SolutionsLandingComponent },
      // Solutions For Business sub-pages
      { path: "solutions/business/automotive-oem", component: AutomotiveOEMComponent },
      { path: "solutions/business", component: ForBusinessComponent },
      { path: "solutions/business/fleet-logistics", component: FleetLogisticsComponent },
      { path: "solutions/business/insurance", component: InsuranceBFSIComponent },
      { path: "solutions/business/enterprise", component: EnterpriseComponent },
      { path: "solutions/consumers", component: ForConsumersComponent },
      // Solutions For Consumers sub-pages
      { path: "solutions/consumers/connected-car", component: ConnectedCarComponent },
      { path: "solutions/consumers/safety-alerts", component: SafetyAlertsComponent },
      { path: "solutions/consumers/rewards", component: ConsumerRewardsComponent },
      { path: "solutions/consumers/device-store", component: DeviceStoreComponent },
      // Contact & About
      { path: "contact-us", component: ContactComponent },
      { path: "about-us", component: AboutUsComponent },
      // Policy pages
      { path: "privacy-policy", component: PrivacyPolicyComponent },
      { path: "refund-and-return-policy", component: RefundAndReturnComponent },
      { path: "cyber-security", component: CyberSecurityComponent },
      { path: "shipping-and-cancellation-policy", component: CancellationPolicyComponent },
      { path: "terms-and-conditions", component: TermsAndConditionsComponent },
      // { path: "business-location", component: BusinessLocationComponent },
      // Admin Pages
      { path: "admin/greetings", component: GreetingsDashboardComponent },
      { path: "careers", loadChildren: () => import('./pages/career-pages/career-pages.module').then(m => m.CareerPagesModule) },
      { path: "store", loadChildren: () => import('./store-module/store/store.module').then(m => m.StoreModule) }
    ]
  },
  {
    path: "mobile/terms-and-conditions", component: EulaWebviewComponent
  },
  {
    path: "mobile/privacy-policy", component: PrivacyPolicyWebviewComponent
  },
  {
    path: "ilassist/privacy-policy", component: IlassistPrivacyPolicyComponent
  },
  {
    path: "mobile/dashcam-installation-video", component: DashcamInstallationVideo
  },
  {
    path: "mobile/camzo-coming-soon", component: CamzoComingSoonComponent
  },
  {
    path: "**", redirectTo: "", pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
